/* src/app/shared/components/access-point-banner/access-point-banner.component.scss */
.ap-tagline {
  color: white;
  font-size: 0.625rem;
  font-weight: 500;
}
:host(.access-point-banner) {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  justify-content: space-around;
  width: 100%;
  height: 1.875rem;
  background-color: #330000;
}
/*# sourceMappingURL=access-point-banner.component.css.map */
